var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "merged-page" },
    [
      _c(
        "AppBreadCrumb",
        { attrs: { paths: [{ title: _vm.$t("message.tags") }], select: true } },
        [
          _c(
            "a-button",
            {
              staticClass: "actionButtonBreadcrumb",
              on: { click: _vm.showModalView },
            },
            [
              _c("md-icon", [_vm._v("add")]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.addTag")) +
                  "\n        "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex w-100",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            {
              staticClass: "side-menubar-wrapper",
              staticStyle: { width: "15%" },
            },
            [_c("ContentsMenu")],
            1
          ),
          _vm._v(" "),
          _c("div", { attrs: { id: "tags" } }, [
            _c(
              "div",
              { staticStyle: { width: "99%" } },
              [
                _c("a-table", {
                  key: "tag_key",
                  staticClass: "custom-table2",
                  attrs: {
                    columns: _vm.cols(),
                    dataSource: _vm.tags.data,
                    loading: _vm.loading,
                    pagination: false,
                    rowKey: "_id",
                    locale: {
                      emptyText: _vm.$t("message.noData"),
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "actionsSlot",
                      fn: function (data, item) {
                        return _c("div", {}, [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex w-100 justify-content-start",
                            },
                            [
                              _c(
                                "a-button",
                                {
                                  staticClass:
                                    "actionButton d-flex align-items-center",
                                  on: {
                                    click: function ($event) {
                                      return _vm.edit(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "margin-right": "16px",
                                        display: "block",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("message.edit")))]
                                  ),
                                  _vm._v(" "),
                                  _c("ActionEdit"),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  staticClass:
                                    "actionButton d-flex align-items-center",
                                  on: {
                                    click: function ($event) {
                                      return _vm.remove(item._id)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "margin-right": "16px",
                                        display: "block",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("message.deleteField"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("ActionDelete"),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      },
                    },
                    {
                      key: "colorSlot",
                      fn: function (data, item) {
                        return _c("div", {}, [
                          _c("div", {
                            staticStyle: {
                              width: "24px",
                              height: "24px",
                              "border-radius": "4px",
                              "box-shadow":
                                "rgb(97 97 97 / 28%) 0px 0px 8px 3px",
                            },
                            style: { backgroundColor: item.color || "#fff" },
                          }),
                        ])
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _vm.isModalShow
                  ? _c(
                      "Modal2",
                      {
                        attrs: {
                          id: "tags-form",
                          title: _vm.editMode
                            ? _vm.$t("message.updateTag")
                            : _vm.$t("message.addTag"),
                          "show-footer": false,
                          rowKey: "_id",
                        },
                        on: { cancel: _vm.hideModal },
                      },
                      [
                        _c(
                          "a-form",
                          {
                            staticClass:
                              "d-flex flex-column justify-content-center",
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.duplicateControl.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "a-row",
                              { staticClass: "mb-3" },
                              [
                                _c(
                                  "a-col",
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("message.tagName"),
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder:
                                              _vm.$t("message.tagName"),
                                          },
                                          model: {
                                            value: _vm.form.name,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "name", $$v)
                                            },
                                            expression: "form.name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "message.tagDescription"
                                          ),
                                        },
                                      },
                                      [
                                        _c("a-textarea", {
                                          attrs: {
                                            placeholder: _vm.$t(
                                              "message.tagDescription"
                                            ),
                                          },
                                          model: {
                                            value: _vm.form.description,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "description",
                                                $$v
                                              )
                                            },
                                            expression: "form.description",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t("message.tagColor"),
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: { type: "color" },
                                          model: {
                                            value: _vm.form.color,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "color", $$v)
                                            },
                                            expression: "form.color",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "a-row",
                              [
                                _c(
                                  "a-col",
                                  { attrs: { id: "buttons" } },
                                  [
                                    _c(
                                      "a-button",
                                      { on: { click: _vm.hideModal } },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(_vm.$t("message.cancel")) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-button",
                                      {
                                        staticClass: "btn-primary",
                                        attrs: {
                                          disabled: _vm.loading,
                                          type: "submit",
                                          variant: "primary",
                                        },
                                        on: { click: _vm.duplicateControl },
                                      },
                                      [
                                        !_vm.loading
                                          ? [
                                              !_vm.editMode
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t("message.save")
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.update"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]),
                                            ]
                                          : [
                                              _c("font-awesome-icon", {
                                                attrs: {
                                                  icon: "spinner",
                                                  spin: "",
                                                },
                                              }),
                                            ],
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isAdmin
                  ? _c("ChatBar", { attrs: { visible: false } })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          !_vm.isAdmin
            ? _c("ChatBar", { attrs: { visible: false } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }